import { Grid, Typography } from "@mui/material";
import PrimaryButton from "components/PrimaryButton";
import SecondaryButton from "components/SecondaryButton";
import { FC, ReactNode, useState } from "react";
import { FormattedMessage } from "react-intl";

export const RemoteAccessConsent: FC<{
  children: ReactNode;
  onConsentRejected: () => void;
}> = ({ children, onConsentRejected }) => {
  const [hasAcceptedConsent, setHasAcceptedConsent] = useState(false);

  if (!hasAcceptedConsent)
    return (
      <Grid container>
        <Grid item>
          <Typography>
            <FormattedMessage id="remoteAccess.requestingConsent" />
          </Typography>
        </Grid>
        <Grid item>
          <PrimaryButton
            data-testid="RemoteConsent-AcceptButton"
            onClick={() => {
              setHasAcceptedConsent(true);
            }}
          >
            <FormattedMessage id="remoteAccess.givePermission" />
          </PrimaryButton>
        </Grid>
        <Grid item>
          <SecondaryButton
            data-testid="RemoteConsent-CancelButton"
            onClick={() => {
              onConsentRejected();
            }}
          >
            <FormattedMessage id="general.cancel" />
          </SecondaryButton>
        </Grid>
      </Grid>
    );

  return <>{children}</>;
};
